import { useEffect, useRef } from "react";
import WaveformPlayer from "@arraypress/waveform-player";

const PLAYER_THEME = {
  waveformStyle: "mirror",
  height: 92,
  barWidth: 2,
  barSpacing: 1,
  buttonAlign: "center",
  showTime: true,
  showPlaybackSpeed: false,
  showBPM: false,
  showMarkers: false,
  enableMediaSession: false,
  waveformColor: "rgba(103, 232, 249, 0.2)",
  progressColor: "#67e8f9",
  buttonColor: "#e2e8f0",
  buttonHoverColor: "#ffffff",
  textColor: "#f8fafc",
  textSecondaryColor: "rgba(148, 163, 184, 0.88)",
  backgroundColor: "rgba(15, 23, 42, 0.72)",
  borderColor: "rgba(34, 211, 238, 0.28)"
};

function normalizeWaveformSrc(value) {
  const raw = String(value || "").trim();
  if (!raw) return "";

  try {
    const parsed = new URL(raw);
    const path = `${parsed.pathname}${parsed.search}${parsed.hash}`;
    if (path.startsWith("/rails/active_storage/") || path.startsWith("/generated/")) {
      return path;
    }
  } catch {
    return raw;
  }

  return raw;
}

export default function WaveformAudioPlayer({ src, title = "Generated voiceover", subtitle = "" }) {
  const containerRef = useRef(null);
  const playerRef = useRef(null);
  const normalizedSrc = normalizeWaveformSrc(src);

  useEffect(() => {
    if (!containerRef.current || !normalizedSrc) return undefined;

    const container = containerRef.current;
    const player = new WaveformPlayer(container, {
      ...PLAYER_THEME,
      url: normalizedSrc,
      title,
      subtitle
    });
    playerRef.current = player;

    return () => {
      playerRef.current?.destroy();
      playerRef.current = null;
    };
  }, [normalizedSrc, title, subtitle]);

  return (
    <div className="ugc-waveform-player-shell rounded-2xl border border-cyan-400/20 bg-[radial-gradient(circle_at_top_left,rgba(34,211,238,0.14),transparent_38%),linear-gradient(180deg,rgba(15,23,42,0.88),rgba(2,6,23,0.96))] p-4 shadow-[0_14px_28px_rgba(2,6,23,.44)]">
      <div ref={containerRef} className="ugc-waveform-player" />
    </div>
  );
}
